import { render, staticRenderFns } from "./PassiveLivenessCheck.vue?vue&type=template&id=0fa49b39"
import script from "./PassiveLivenessCheck.vue?vue&type=script&lang=js"
export * from "./PassiveLivenessCheck.vue?vue&type=script&lang=js"
import style0 from "./PassiveLivenessCheck.vue?vue&type=style&index=0&id=0fa49b39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports